// InputSection.js
import React from "react";
import Increment from "./Increment";
import Decrement from "./Decrement";

const InputSection = ({
  title,
  value,
  actionTypeIncrement,
  actionTypeDecrement,
  actionTypeInput,
  dispatch,
  id
}) => {
  const handleInputChange = (e) => {
    dispatch({
      type: actionTypeInput,
      payload: e.target.value,
    });
  };

  return (
    <div className="form-builder-section-div">
      <p>{title}</p>
      <div className="counter-div">
        <input
          type="number"
          value={value}
          onChange={handleInputChange}
          onKeyDown={(evt) =>
            (evt.key === "e" || evt.key === "E" || evt.key === "-") &&
            evt.preventDefault()
          }
          id={id}
        />
        <div style={{display: "flex", flexDirection: "column", gap: "2px"}}>
          <Increment actionType={actionTypeIncrement} dispatch={dispatch} />
          <Decrement actionType={actionTypeDecrement} dispatch={dispatch} />
        </div>
      </div>
    </div>
  );
};

export default InputSection;